export default "__VITE_ASSET__CnFsXey2__"